import { render } from "./new-prevision.vue?vue&type=template&id=476fdc07"
import script from "./new-prevision.vue?vue&type=script&lang=js"
export * from "./new-prevision.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__